import React, { useState } from 'react'
import { Carousel } from 'react-bootstrap';
import '../../stylings/carouselSection.css'
import ndrf        from '../../assest/lifeatschool/NDRF.jpeg'
import building1   from '../../assest/building1.jpg'
import christmas   from '../../assest/lifeatschool/Christmas.jpeg'
import computerlab from '../../assest/lifeatschool/Computer.jpeg'
import directors   from '../../assest/lifeatschool/DirectorsDiff.jpeg'
import winning     from '../../assest/lifeatschool/WinningTropphy.jpeg'
import yoga        from '../../assest/lifeatschool/Yoga.jpeg'
import gemofschool from '../../assest/lifeatschool/DPLPic1.jpg'

const slides = [
  {
    id: 111,
    badge:    'Excellence in Education',
    title:    'GEM of Our School',
    subtitle: 'Celebrating the brightest talents who bring pride to Vidya Jain Convent School.',
    cta:      { label: 'Know More', link: '/about-school' },
    image:    gemofschool,
  },
  {
    id: 1,
    badge:    'Safety & Awareness',
    title:    'NDRF Training Session',
    subtitle: 'A special session conducted by NDRF to educate students on disaster preparedness.',
    cta:      { label: 'View Gallery', link: '/galleryall' },
    image:    ndrf,
  },
  {
    id: 2,
    badge:    'Our Campus',
    title:    'Vidya Jain Convent School',
    subtitle: 'A nurturing environment built for holistic learning, growth, and excellence.',
    cta:      { label: 'About School', link: '/about-school' },
    image:    building1,
  },
  {
    id: 3,
    badge:    'Celebrations',
    title:    'Christmas Celebration 2024',
    subtitle: 'Spreading joy and festive spirit — 25th December celebrated with great enthusiasm.',
    cta:      { label: 'View Gallery', link: '/galleryall' },
    image:    christmas,
  },
  {
    id: 4,
    badge:    'Smart Learning',
    title:    'State-of-the-Art Computer Lab',
    subtitle: 'Equipping students with digital skills through our fully equipped computer laboratory.',
    cta:      { label: 'Academics', link: '#' },
    image:    computerlab,
  },
  {
    id: 5,
    badge:    'Achievements',
    title:    "Teachers' Cricket Championship",
    subtitle: 'Directors from various schools gathered during the prize distribution of TCC.',
    cta:      { label: 'View Gallery', link: '/galleryall' },
    image:    directors,
  },
  {
    id: 6,
    badge:    'Team Spirit',
    title:    'TCC Championship Winners',
    subtitle: 'Congratulating our teachers on their outstanding victory at the TCC tournament.',
    cta:      { label: 'View Gallery', link: '/galleryall' },
    image:    winning,
  },
  {
    id: 7,
    badge:    'Health & Wellness',
    title:    'Yoga Day at School',
    subtitle: 'Promoting physical and mental well-being through regular yoga sessions for all students.',
    cta:      { label: 'Know More', link: '/about-school' },
    image:    yoga,
  },
]

const CarouselSection = () => {
  const [index, setIndex] = useState(0)

  return (
    <div className="hero-slider">
      <Carousel
        activeIndex={index}
        onSelect={setIndex}
        interval={5000}
        pause={false}
        prevIcon={
          <span className="hero-arrow hero-arrow--prev" aria-hidden="true">
            <i className="fa-solid fa-chevron-left"></i>
          </span>
        }
        nextIcon={
          <span className="hero-arrow hero-arrow--next" aria-hidden="true">
            <i className="fa-solid fa-chevron-right"></i>
          </span>
        }
        indicators={false}
      >
        {slides.map((slide) => (
          <Carousel.Item key={slide.id}>
            <div className="hero-slide">
              {/* Ken-Burns zoom image */}
              <img
                className="hero-slide-img"
                src={slide.image}
                alt={slide.title}
              />
              {/* dark overlay */}
              <div className="hero-slide-overlay"></div>

              {/* Text content */}
              <div className="hero-slide-content">
                <span className="hero-badge">
                  <i className="fa-solid fa-circle-dot"></i>
                  {slide.badge}
                </span>
                <h1 className="hero-title">{slide.title}</h1>
                <p className="hero-subtitle">{slide.subtitle}</p>
                <a href={slide.cta.link} className="hero-cta">
                  {slide.cta.label}
                  <i className="fa-solid fa-arrow-right"></i>
                </a>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Custom dot indicators */}
      <div className="hero-dots">
        {slides.map((slide, i) => (
          <button
            key={slide.id}
            className={'hero-dot' + (i === index ? ' hero-dot--active' : '')}
            onClick={() => setIndex(i)}
            aria-label={'Go to slide ' + (i + 1)}
          />
        ))}
      </div>

      {/* Slide counter */}
      <div className="hero-counter">
        <span className="hero-counter-current">{String(index + 1).padStart(2, '0')}</span>
        <span className="hero-counter-sep"></span>
        <span className="hero-counter-total">{String(slides.length).padStart(2, '0')}</span>
      </div>
    </div>
  )
}

export default CarouselSection
